export enum SupportProductValidation {
	AtleastOneAsset,
}
